export default [
    {
        path: 'sala-vacinacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-sala-vacinacao' */ '@/views/imunizacao/sala-vacinacao/Index'),
        redirect: 'sala-vacinacao/index',
        children: [
            {
                name: 'imunizacao-sala-vacinacao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-sala-vacinacao' */ '@/views/imunizacao/sala-vacinacao/List.vue'),
            },
            {
                name: 'imunizacao-sala-vacinacao-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-sala-vacinacao' */ '@/views/imunizacao/sala-vacinacao/Form.vue'),
            },
            {
                name: 'imunizacao-sala-vacinacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-sala-vacinacao' */ '@/views/imunizacao/sala-vacinacao/Form.vue'),
            },
        ],
    },
]